import request from '@/utils/request';
export const fileTransferHeaders = {};
export const defaultOrdersDispatchData = {
  id: 0,
  enabled: true,
  orderId: undefined,
  dealersTransporterId: null,
  adminId: undefined,
  unitId: undefined,
  agentId: undefined,
  dealerId: undefined,
  quantity: 0,
  dispatchDate: null,
  entryNumber: null,
  markaNumber: null,
  markaDate: null,
  privateMarka: null,
  accountType: undefined,
  looseCartonCount: 0,
  standardCartonCount: 0,
  totalCartonCount: 0,
  comments: null,
  invoiceAttachment: null,
  otherAttachment: null,
  ordersProductsDispatch: [],
  status: undefined,
  totalInstallationCharge: 0,
  daliDriverConfigCharges: 0,
  engravingCharges: 0,
  dealersTransporter: {
    id: null
  },
  admin: {
    id: null
  },
  unit: {
    id: null
  },
  agent: {
    id: null
  },
  dealer: {
    id: null
  },
  lrNumber: null,
  lrDate: null,
  deliveryAddressId: null,
  billingAddressId: null,
  vehicleNumber: null
};
export const getOrdersDispatches = params => request({
  url: '/orders-dispatches',
  method: 'get',
  params
});
export const getDealerReports = params => request({
  url: '/orders-dispatches/report',
  method: 'get',
  params
});
export const downloadCSV = data => request({
  url: '/orders-dispatches/download-csv',
  method: 'post',
  data,
  responseType: 'blob'
});
export const downloadExcel = data => request({
  url: '/reports/download-excel',
  method: 'post',
  data,
  responseType: 'blob'
});
export const downloadPaymentExcel = data => request({
  url: '/reports/download-payment-excel',
  method: 'post',
  data,
  responseType: 'blob'
});
export const downloadHsnExcel = data => request({
  url: '/reports/download-excel',
  method: 'post',
  data,
  responseType: 'blob'
});
export const getGrandTotal = params => request({
  url: '/reports/sales-report-grandTotal',
  method: 'GET',
  params
});
export const createOrdersDispatch = data => request({
  url: '/orders-dispatches/add',
  method: 'post',
  data
});
export const getOrdersDispathById = id => request({
  url: `/orders-dispatches/${id}`,
  method: 'get'
});
export const updateDepoDispatch = (id, data) => request({
  url: `/orders-products-dispatches/update-depo-dispatch/${id}`,
  method: 'patch',
  data
});
export const updateLrOrdersDispath = (id, data) => request({
  url: `/orders-dispatches/update-lr/${id}`,
  method: 'post',
  data
});
export const updateOrdersDispath = (id, data) => request({
  url: `/orders-dispatches/${id}`,
  method: 'patch',
  data
});
export const updateOrdersDispathNew = (id, data) => request({
  url: `/orders-dispatches/update-dispatch/${id}`,
  method: 'patch',
  data
});
export const fetchPendingDispatch = data => request({
  url: '/orders-products/pending-dispatch',
  method: 'post',
  data
});
export const generateFax = params => request({
  url: '/orders-dispatches/fax',
  method: 'get',
  params
});
export const generateFaxWithoutDealer = params => request({
  url: '/orders-dispatches/fax-no-dealer',
  method: 'get',
  params
});
export const generateSlip = params => request({
  url: '/orders-dispatches/slip',
  method: 'get',
  params
});
/**
 * it will create new invoice & override existing data in dbd
 * do not use always
 */
export const viewInvoice = id => request({
  url: `/orders-dispatches/invoice-preview/${id}`,
  method: 'get'
});
/**
 * it will create invoice once & override existing data in db once
 * rest generated invoice will be returned
 */
export const generateInvoice = id => request({
  url: `/orders-dispatches/get-invoice/${id}`,
  method: 'get'
});
export const getPendingOrdersProducts = params => request({
  url: '/orders-products/pending-dispatch',
  method: 'get',
  params
});
export const getDealerWisePendingOrdersdProducts = params => request({
  url: '/orders-products/dealer-wise-pending-orders-products',
  method: 'get',
  params
});
export const getDispatchCount = params => request({
  url: '/orders-dispatches/count/status',
  method: 'get',
  params
});
export const generateEway = id => request({
  url: `/orders-dispatches/eway/${id}`,
  method: 'get'
});
export const downloadExcelInvoiceManager = data => request({
  url: '/orders-dispatches/download-excel-invoice-manager',
  method: 'post',
  data,
  responseType: 'blob'
});
export const cancelEway = id => request({
  url: `/orders-dispatches/cancel-eway/${id}`,
  method: 'get'
});
export const generateEInvoice = id => request({
  url: `/orders-dispatches/einvoice/${id}`,
  method: 'get'
});
export const cancelEInvoice = id => request({
  url: `/orders-dispatches/cancel-einvoice/${id}`,
  method: 'get'
});
export const fetchOutstandingDealers = data => request({
  url: '/orders-dispatches/outstanding-list',
  method: 'post',
  data
});
export const downloadExcelOS = data => request({
  url: '/orders-dispatches/download-excel-out-standing',
  method: 'post',
  data,
  responseType: 'blob'
});
export const fetchOverdueByDays = data => request({
  url: '/orders-dispatches/overdue-by-days',
  method: 'post',
  data
});
export const downloadPendingOrdersProducts = params => request({
  url: '/orders-products/download-pending-dispatch',
  method: 'get',
  params
});
export const downloadDealerWiseExcel = data => request({
  url: '/orders-products/download-excel-pending-orders-products-dealer-wise',
  method: 'post',
  data,
  responseType: 'blob'
});
export const downloadMergedInvoiceEwayPdf = id => request({
  url: `/orders-dispatches/mergePdf/${id}`,
  method: 'get'
});
export const updateEway = data => request({
  url: '/orders-dispatches/update-eway',
  method: 'post',
  data
});
export const uploadEwayPdf = data => request({
  url: '/orders-dispatches/upload-eway-pdf',
  method: 'post',
  data
});
export const dealerSalesReport = params => request({
  url: '/reports/sales-report',
  method: 'get',
  params
});
export const dealersCombinedReport = params => request({
  url: '/reports/combined-report',
  method: 'get',
  params
});
export const dealerPaymentsReport = params => request({
  url: '/reports/payments-report',
  method: 'get',
  params
});
export const downloadCombinedExcel = data => request({
  url: '/reports/download-excel-combined',
  method: 'post',
  data,
  responseType: 'blob'
});
export const getHsnReport = params => request({
  url: '/reports/hsn',
  method: 'get',
  params
});
export const regenerateInvoice = id => request({
  url: `/orders-dispatches/generate-invoice-and-upload-to-s3/${id}`,
  method: 'post',
  data: {
    idsToProcess: [id]
  }
});
export const updateAmountInLedger = id => request({
  url: `/orders-dispatches/update-amount-in-ledger/${id}`,
  method: 'post'
});
export const getFinancialYear = () => request({
  url: 'reports/financial-year',
  method: 'get'
});
export const downloadExcelOverdue = data => request({
  url: '/orders-dispatches/download-excel-overdue',
  method: 'post',
  data,
  responseType: 'blob'
});
export const downloadPdfOverdue = data => request({
  url: '/orders-dispatches/download-pdf-overdue',
  method: 'post',
  data,
  responseType: 'blob'
});
export const dealerWiseOsOdReport = data => request({
  url: '/reports/dealer-wise-os-od',
  method: 'post',
  data
});
export const downloadOsOdExcel = data => request({
  url: '/reports/download-excel-os-od',
  method: 'post',
  data,
  responseType: 'blob'
});
export const getOnlyOrdersProducts = data => request({
  url: '/orders-products/get-only-orders-products',
  method: 'post',
  data
});
export const searchEntryNumber = params => request({
  url: '/orders-dispatches/entry-number/search',
  method: 'get',
  params
});
export const downloadInvoiceAgeingPdf = data => request({
  url: '/reports/download-invoice-ageing-pdf',
  method: 'post',
  data
});
export const clearOsOdCache = data => request({
  url: '/reports/clear-os-od-cache',
  method: 'post',
  data
});
export const addTallyDispatch = data => request({
  url: '/orders-dispatches/add-tally-dispatch',
  method: 'post',
  data
});
export const getTop50DealersSales = params => request({
  url: '/reports/top-50-dealers-sales',
  method: 'get',
  params
});
export const getTop50DealersPayments = params => request({
  url: '/reports/top-50-dealers-payments',
  method: 'get',
  params
});
export const fetchStateWiseSales = params => request({
  url: '/reports/state-wise-sales',
  method: 'get',
  params
});
export const fetchStateWiseRangeSales = params => request({
  url: '/reports/state-wise-range-sales',
  method: 'get',
  params
});
export const fetchMonthWiseRangeSales = params => request({
  url: '/reports/month-wise-range-sales',
  method: 'get',
  params
});
export const addAdditionalCharges = (id, data) => request({
  url: `/orders-dispatches/add-additional-charges/${id}`,
  method: 'post',
  data
});